import React from "react";
import styled, { keyframes } from "styled-components";

const rotate = keyframes`
    from { 
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const Loader = styled.div`
  display: inline-block !important;
  position: fixed;
  top: 50%;
  left: 50%;
  height: 64px;
  width: 64px;
  transform: translate(-50%, -50%);
  span {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 6px;
    border: 6px solid ${props => props.theme.primary};
    border-radius: 50%;
    animation: ${rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${props => props.theme.primary} transparent transparent
      transparent;
  }
  span:nth-child(1) {
    animation-delay: -0.45s;
  }
  span:nth-child(2) {
    animation-delay: -0.3s;
  }
  span:nth-child(3) {
    animation-delay: -0.15s;
  }
`;

function Loading() {
  return (
    <Loader>
      <span />
      <span />
      <span />
      <span />
    </Loader>
  );
}

export default Loading;
